import React from "react";
import classes from "./FlexTable3Col1Start.module.css";

/* versions:

  originated from FlexTable3Col1.js

  0 - this version allows to have flexible tool section
  current - last column has flex start style

    props list : {
        title: {
            col1, 
            col2,
            col3
        },
        data: {
          col1,
          col2, 
          col3 - key, 
        }, 
        addOnComp
    }
*/

const FlexTable3Col1Start = (props) => {
  let title;
  if (props.title) {
    title = props.title;
  }

  const note = <p className={classes.note}>Hiện không có nhóm đối tượng nào!!</p>

  return (
    <div className={classes.container}>
      <div className={`${classes.row} ${classes.header}`}>
        <div>{title.col1}</div>
        <div>{title.col2}</div>
        <div>{title.col3}</div>
      </div>
      {props.data.length > 0 &&
        props.data.map((item, index) => (
          <div className={classes.row} key={item.col3}>
            <div className={classes.index}>{index + 1}</div>
            <div className={classes.info}>
              <p>{item.col1}</p>
              <p>{item.col2}</p>
            </div>
            {/* <div>{props.addOnComp(item.col3)}</div> */}
            {/* <p>{item.col3}</p> */}
            {props.addOnComp(item.col3)}
          </div>
        ))
        }
        {props.data.length === 0 && note} 
    </div>
  );
};

export default FlexTable3Col1Start;
